'use client';

import { Box } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface Props {
  size?: 'small' | 'regular' | 'large';
  children: ReactNode | Array<ReactNode>;
  fontWeight?: 'light' | 'regular' | 'medium' | 'bold' | 'bolder';
  textAlign?: 'left' | 'center' | 'right';
  color?: 'text/body' | 'text/secondary' | 'text/eyebrow';
}

const Text = ({ size = 'regular', color = 'text/body', children, ...rest }: Props) => {
  return (
    <Box
      as="p"
      textStyle={`body.${size}`}
      sx={{
        m: 0,
        color
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default Text;
